"use client";
import { WEB_COLORS } from "@/lib/constants";
import { useGetBankListQuery } from "@/lib/redux";
import {
  Autocomplete,
  Grid,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import Image from "next/image";
import ButtonComponent from "./Button";
import LoaderComponent from "./Loader";
import PaperComponent from "./Paper";
import DrawerComponent from "./Drawer";
import { Search } from "@mui/icons-material";
import { useState } from "react";

const BankSelectionDrawer = ({
  open,
  handleModal,
  setBankSelection,
  extraFunction,
}) => {
  const { data: banksList, isFetching } = useGetBankListQuery();
  const [isFocused, setIsFocused] = useState(false);
  const popularBanks = banksList?.data?.map(
    ({ bank, is_popular, logo_url, extraFunction, ...item }) => {
      if (is_popular === 1) {
        return (
          <Grid item key={bank} xs={12} sm={6} md={4} lg={3}>
            <PaperComponent
              elevation={0}
              onClick={() => {
                setBankSelection({ ...item, bank, is_popular, logo_url });
                handleModal(false);
              }}
              paperStyle={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: `1px solid rgba(77, 103, 103, 0.05)`,
                backgroundColor: "rgba(242, 247, 247, 0.1)",
                height: "100%",
                "&:hover": {
                  cursor: "pointer",
                },
              }}
            >
              <Stack alignItems={"center"} rowGap={1} justifyContent={"center"}>
                <Image src={logo_url} alt="bank Image" height={40} width={40} />
                <Typography
                  align="center"
                  fontSize={{ xs: 14, sm: 12, md: 14 }}
                  sx={{ textTransform: "capitalize" }}
                >
                  {bank.toLowerCase()}
                </Typography>
              </Stack>
            </PaperComponent>
          </Grid>
        );
      }
    }
  );
  const otherBanks = banksList?.data?.map(
    ({ bank, is_popular, logo_url, ...item }) => {
      if (is_popular !== 1) {
        return (
          <PaperComponent
            onClick={() => {
              setBankSelection({ ...item, bank, is_popular, logo_url });
              handleModal(false);
            }}
            elevation={0}
            key={bank}
            sx={{
              my: 0.5,
              "&:hover": {
                cursor: "pointer",
              },
            }}
          >
            <Stack alignItems={"center"} direction={"row"}>
              <PaperComponent
                elevation={0}
                p={0}
                paperStyle={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: `1px solid rgba(77, 103, 103, 0.20)`,
                  position: "relative",
                  py: { xs: 0, sm: 0 },
                  px: { xs: 0, sm: 0 },
                  borderRadius: 2,
                }}
              >
                <Image src={logo_url} alt="bank Image" height={40} width={40} />
              </PaperComponent>
              <Typography
                align="center"
                sx={{ textTransform: "capitalize", ml: 2 }}
              >
                {bank.toLowerCase()}
              </Typography>
            </Stack>
          </PaperComponent>
        );
      }
    }
  );
  return (
    <DrawerComponent
      title={"Select your preferred Bank"}
      open={open}
      handleDrawer={handleModal}
      extraFunction={extraFunction}
    >
      <Stack px={2}>
        <LoaderComponent open={isFetching} />
        {banksList?.data ? (
          <>
            <Stack spacing={1}>
              <Autocomplete
                options={banksList?.data}
                getOptionLabel={(option) => option.bank}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Search Bank Name"
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    InputLabelProps={{
                      shrink: isFocused || Boolean(params.inputProps?.value),
                      sx: {
                        pl: !(isFocused || Boolean(params.inputProps?.value))
                          ? 2.5
                          : 0,
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <>
                          <InputAdornment position="start">
                            <Search fontSize="small" />
                          </InputAdornment>
                          {params.InputProps.startAdornment}
                        </>
                      ),
                    }}
                  />
                )}
                onChange={(event, newValue) => {
                  setBankSelection(newValue);
                  handleModal(false);
                }}
              />
              <Typography>Popular Banks</Typography>
              <Grid container spacing={2} width={"100%"}>
                {popularBanks}
              </Grid>
            </Stack>
            <Typography mt={6}>Other Banks</Typography>
            <Stack>{otherBanks}</Stack>
          </>
        ) : (
          <Stack>
            <ButtonComponent>Fetch Bank Data</ButtonComponent>
          </Stack>
        )}
      </Stack>
    </DrawerComponent>
  );
};

export default BankSelectionDrawer;
